import * as t from "io-ts";
import { ControlV } from "./controls";
import { DynamicFieldReturnTypeV } from "@/types/dynamic-property-path";

export const DynamicFieldV = t.intersection([
  t.type({
    category:
      t.string /* probably better to have it as an array of tags, for searchability in the UI */,
    slug: t.string,
    label: t.string,
    controls: t.array(ControlV),
    returnTypes: t.array(DynamicFieldReturnTypeV)
  }),
  t.partial({
    proOnly: t.boolean,
    subcategory: t.string,
    defaultAttributes: t.union([
      t.record(t.string, t.string),
      // t.array(t.undefined) is to handle the empty state,
      // which comes from PHP as an empty array
      t.array(t.undefined)
    ])
  })
]);

export type DynamicField = t.TypeOf<typeof DynamicFieldV>;

export const DynamicDataAdvancedAttributesV = t.type({
  fallback: t.string,
  beforeContent: t.string,
  afterContent: t.string
});
export type DynamicDataAdvancedAttributes = t.TypeOf<
  typeof DynamicDataAdvancedAttributesV
>;

export const DynamicDataAttributesV = t.record(
  t.string,
  t.union([t.string, t.number, t.record(t.string, t.string)])
);
export type DynamicDataAttributes = t.TypeOf<typeof DynamicDataAttributesV>;

export const DynamicFieldOutputV = t.type({
  shortcode: t.string,
  field: DynamicFieldV,
  // t.array(t.undefined) is to handle the empty state,
  // which comes from PHP as an empty array
  attributes: t.union([DynamicDataAttributesV, t.array(t.undefined)])
});

export type DynamicFieldOutput = t.TypeOf<typeof DynamicFieldOutputV>;

export const DynamicFieldsV = t.array(DynamicFieldV);

export const DynamicDataV = t.partial({
  [typeof String]: t.string
});

export type DynamicData = t.TypeOf<typeof DynamicDataV>;
